import { Button } from '@material-ui/core'
import React from 'react';
import "./OrderAdminRow.css"

function OrderAdminRow({id, total, date}) {
    return (
        <div className="orderRow">
           <span className="orderID">{id}</span>
           <span className="orderDate">{date}</span>
           <span className="orderAmount">{total}</span>
           <Button className="deliveryStatus">Delivered</Button>
        </div>
    )
}

export default OrderAdminRow
